import React from "react";
import Headers from "../components/Header";
import Footer from "../Screen/Footer";

const TermsandCondition = () => {
  return (
    <div>
      <Headers />
      <section className="container terms-page">
        <h2 className="mb-3">Terms & Conditions</h2>

        <p className="mb-3">
          By accessing or using{" "}
          <span style={{ fontWeight: "bold" }}>Blaccdot Canada</span>{" "}
          (“Blaccdot”, “we”, “our”, or “us”), including any website, platform,
          dashboard, or service operated under Blaccdot Canada, you agree to be
          bound by the following Terms and Conditions. If you do not agree with
          any part of these terms, you must not use our website or services.
        </p>
        <p className="mb-3">
          Blaccdot Canada reserves the right to modify, update, or replace these
          Terms and Conditions at any time without prior notice. Continued use
          of the website constitutes acceptance of the revised terms.{" "}
        </p>
        <ol>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Use of the Website</span>
            <p>
              Blaccdot Canada provides lead generation, lead distribution, and
              related digital marketing services. By using this website, you
              agree to:
            </p>
            <ul>
              <li className="my-3">Use the website only for lawful purposes</li>
              <li className="mb-3">
                Provide accurate, current, and complete information
              </li>
              <li className="mb-3">
                Not misuse, interfere with, or disrupt the website or its
                services{" "}
              </li>
            </ul>
            <p>
              Unauthorized use of this website may result in termination of
              access.
            </p>
          </li>

          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Non-Liability Disclaimer</span>
            <p>
              While Blaccdot Canada makes reasonable efforts to ensure the
              accuracy and quality of information and leads provided, we do{" "}
              <span style={{ fontWeight: "bold" }}>not guarantee:</span>
            </p>
            <ul>
              <li className="my-3">Lead conversion</li>
              <li className="mb-3">Business outcomes or revenue </li>
              <li className="mb-3">Marketing performance or placement</li>
              <li>Accuracy or completeness of third-party information</li>
            </ul>
            <p>
              All services and information are provided{" "}
              <span style={{ fontWeight: "bold" }}>“as is”.</span> Blaccdot
              Canada shall not be held liable for any direct, indirect,
              incidental, consequential, or business losses arising from the use
              of our website or services
            </p>
            <p>
              Pricing, services, and features may be modified at any time
              without notice.{" "}
            </p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Account Registration</span>
            <p>
              You may browse the website without registering. However,
              registration is required to access paid services.
            </p>
            <p>By registering, you agree to: </p>
            <ul>
              <li className="my-3">
                Provide truthful and accurate information
              </li>
              <li className="mb-3">
                Not impersonate another individual or entity
              </li>
              <li className="mb-3">
                Maintain the confidentiality of your login credentials
              </li>
            </ul>
            <p>
              Blaccdot Canada reserves the right to suspend or terminate
              accounts that provide false, misleading, or incomplete
              information.
            </p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>
              User Responsibilities & Restrictions
            </span>
            <p>
              Users agree{" "}
              <span style={{ fontWeight: "bold" }}>not to:</span>{" "}
            </p>

            <ul>
              <li className="my-3">
                Copy, modify, distribute, sell, or exploit any website content
              </li>
              <li className="mb-3">
                Upload or transmit viruses, malware, or harmful code
              </li>
              <li className="my-3">
                Send spam, misleading information, or unlawful material{" "}
              </li>

              <li className="mb-3">
                Reverse-engineer or attempt to access restricted systems
              </li>
              <li className="mb-3">
                Misuse leads, data, or proprietary information
              </li>
            </ul>
            <p>
              All intellectual property belongs exclusively to Blaccdot Canada
              or its licensors.
            </p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Commercial Use of Leads</span>

            <p>
              Leads provided by Blaccdot Canada are intended solely for the
              registered customer’s internal business use. Reselling, sharing,
              redistributing, or publicly displaying leads without written
              permission is strictly prohibited.
            </p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Third-Party Links</span>

            <p>
              Our website may contain links to third-party websites. Blaccdot
              Canada does not control or endorse these sites and is not
              responsible for their content, accuracy, or policies.{" "}
            </p>
            <p>
              Accessing third-party links is done{" "}
              <span style={{ fontWeight: "bold" }}>at your own risk.</span>
            </p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>
              Intellectual Property Rights
            </span>

            <p>
              All content on Blaccdot Canada, including but not limited to:{" "}
            </p>
            <ul>
              <li>Text</li>
              <li>Graphics</li>
              <li>Logos</li>
              <li>Software</li>
              <li>Data</li>
              <li>Designs</li>
              <p>
                is protected by copyright, trademark, and intellectual property
                laws. Unauthorized use is strictly prohibited.
              </p>
            </ul>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Indemnification</span>

            <p>
              You agree to indemnify and hold harmless Blaccdot Canada, its
              owners, directors, employees, agents, and service providers from
              any claims, damages, losses, liabilities, or expenses arising out
              of:
            </p>
            <ul>
              <li>Your use of the website</li>
              <li>Violation of these Terms</li>
              <li>Misuse of leads or services</li>
            </ul>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Warranty Disclaimer</span>

            <p>
              Blaccdot Canada provides the website and services{" "}
              <span style={{ fontWeight: "bold" }}>
                without warranties of any kind,
              </span>{" "}
              express or implied. We do not guarantee that:
            </p>
            <ul>
              <li>The website will be uninterrupted or error-free</li>
              <li>Data will be free from viruses or harmful components</li>
            </ul>
            <p>Use of the website is at your own risk.</p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Limitation of Liability</span>

            <p>
              To the maximum extent permitted by law, Blaccdot Canada shall not
              be liable for:{" "}
            </p>
            <ul>
              <li>Loss of profits</li>
              <li>Business interruption</li>
              <li>Data loss</li>
              <li>Indirect or consequential damages</li>
            </ul>
            <p>
              Our total liability, if any, shall not exceed the amount paid by
              the customer for services in the preceding billing period.
            </p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Termination</span>

            <p>
              Blaccdot Canada reserves the right to suspend or terminate access
              to the website or services at any time, without notice, for
              violations of these Terms.
            </p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Feedback & Suggestions</span>

            <p>
              Any feedback, ideas, or suggestions submitted to Blaccdot Canada
              become our property. We may use them without compensation or
              obligation.
            </p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Prohibited Content</span>

            <p>Users must not upload or transmit content that is:</p>
            <ul>
              <li>Illegal, offensive, abusive, or discriminatory</li>
              <li>Sexually explicit or pornographic</li>
              <li>Copyright-protected without authorization</li>
              <li>Misleading or defamatory</li>
            </ul>
            <p>
              Blaccdot Canada reserves the right to remove such content and
              terminate accounts.{" "}
            </p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Severability & No Waiver</span>

            <p>
              If any provision of these Terms is found unenforceable, the
              remaining provisions shall remain in full force. Failure to
              enforce any right does not constitute a waiver.
            </p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Governing Law</span>

            <p>
              These Terms and Conditions are governed by the laws of{" "}
              <span style={{ fontWeight: "bold" }}>
                British Columbia, Canada.
              </span>{" "}
              Any disputes shall be resolved exclusively in the courts of
              British Columbia.
            </p>
          </li>
          <li className="mb-3">
            <span style={{ fontWeight: "bold" }}>Contact Information</span>

            <p>For any questions regarding these Terms, please contact:</p>
            <ul>
              <li>
                <span style={{ fontWeight: "bold" }}>📧 Email:</span>
                <a
                  href="mailto:support@blaccdot.ca"
                  className="text-blue-600 underline hover:text-blue-800"
                >
                  support@blaccdot.ca
                </a>
              </li>
              <li>
                {" "}
                <span style={{ fontWeight: "bold" }}>🌐 Website:</span>{" "}
                blaccdot.ca
              </li>
            </ul>
          </li>
        </ol>
      </section>

      <Footer />
    </div>
  );
};

export default TermsandCondition;
